// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__3-OZl","menuText":"style_menuText__IZY9Q","inputBox":"style_inputBox__MNWiS","search":"style_search__35hXd","subcategoryLink":"style_subcategoryLink__1KIsK"};